// Active-filter chips row with response count summary, clear button, and per-chip remove.

import {
    Button,
    Tooltip,
    Typography,
} from "@material-tailwind/react";
import MaterialIcon from "components/material-icon";
import { CHIP_TRUNCATE_LENGTH } from "../theming-tab.config";

function truncate(str, maxlength) {
    return str.length > maxlength ? str.slice(0, maxlength - 1) + "…" : str;
}

export default function FilterChips({
    responseNoDisplay,
    totalEntries,
    filters,
    onClear,
    onRemoveFilter,
    onToggleUnthemed,
}) {
    return (
        <div className="flex items-center gap-2 flex-wrap">
            <Typography variant="paragraph" className="text-black">
                {responseNoDisplay} of {totalEntries || 0} Responses
            </Typography>
            <Button
                size="sm"
                className="btn btn--danger"
                onClick={onClear}
            >
                Clear filters
            </Button>
            {/* Question Filters */}
            {filters?.questions?.map((question) => (
                <span
                    key={question.id}
                    className="inline-flex items-center px-3 py-1 rounded-full bg-gray-200 text-black mr-2"
                >
                    Q{question.position}
                    <Button
                        variant="text"
                        size="sm"
                        className="p-0 h-4 w-4 ml-1 text-black"
                        onClick={() =>
                            onRemoveFilter("questions", question.id)
                        }
                    >
                        <MaterialIcon name="close" color="black" />
                    </Button>
                </span>
            ))}
            {/* Text Filters */}
            {filters?.texts?.map((filter) => (
                <div key={filter.id}>
                    {!!(filter?.text?.length) && (
                        <Tooltip content={filter.text}>
                            <span className="inline-flex items-center px-3 py-1 rounded-full bg-cta text-black mr-2 border border-gray-300 gap-2">
                                <MaterialIcon
                                    name="text_fields"
                                    size="sm"
                                    color="black"
                                />
                                {truncate(filter.text, CHIP_TRUNCATE_LENGTH)}
                                <Button
                                    variant="text"
                                    size="sm"
                                    className="p-0 h-4 w-4 ml-1 text-black"
                                    onClick={() =>
                                        onRemoveFilter("texts", filter.id)
                                    }
                                >
                                    <MaterialIcon
                                        name="close"
                                        color="black"
                                    />
                                </Button>
                            </span>
                        </Tooltip>
                    )}
                </div>
            ))}
            {/* Theme Filters (T: icon) */}
            {filters?.themes?.map((filter) => (
                <div key={filter.id}>
                    {!!(filter?.name?.length) && (
                        <Tooltip content={filter.name}>
                            <span className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 text-black mr-2">
                                T: {truncate(filter.name, CHIP_TRUNCATE_LENGTH)}
                                <Button
                                    variant="text"
                                    size="sm"
                                    className="p-0 h-4 w-4 ml-1 text-black"
                                    onClick={() =>
                                        onRemoveFilter(
                                            "themes",
                                            filter.id,
                                        )
                                    }
                                >
                                    <MaterialIcon
                                        name="close"
                                        color="black"
                                    />
                                </Button>
                            </span>
                        </Tooltip>
                    )}
                </div>
            ))}
            {/* Keyword Filters */}
            {filters?.keywords?.map((filter) => (
                <div key={filter.id}>
                    {!!(filter?.text?.length) && (
                        <Tooltip content={filter.text}>
                            <span className="inline-flex items-center px-3 py-1 rounded-full bg-cta text-black mr-2">
                                {truncate(filter.text, CHIP_TRUNCATE_LENGTH)}
                                <Button
                                    variant="text"
                                    size="sm"
                                    className="p-0 h-4 w-4 ml-1 text-black"
                                    onClick={() =>
                                        onRemoveFilter(
                                            "keywords",
                                            filter.id,
                                        )
                                    }
                                >
                                    <MaterialIcon
                                        name="close"
                                        color="black"
                                    />
                                </Button>
                            </span>
                        </Tooltip>
                    )}
                </div>
            ))}
            {/* Unthemed Filter */}
            {filters?.unthemed && (
                <span className="inline-flex items-center px-3 py-1 rounded-full bg-purple-100 text-black mr-2">
                    Unthemed
                    <Button
                        variant="text"
                        size="sm"
                        className="p-0 h-4 w-4 ml-1 text-black"
                        onClick={() => onToggleUnthemed(false)}
                    >
                        <MaterialIcon name="close" color="black" />
                    </Button>
                </span>
            )}
        </div>
    );
}
